import { clearPendingTenantClientId, getLogoutHandoffClientId, isValidClientId } from './clientIdStorage';

import { RouterUrls } from '../router/RouterUrls';

export const prepareAuthUrl = (): string | null => {
  const url = new URL(window.location.href);
  const urlClientId = url.searchParams.get('clientId');
  const isAuthPage = url.pathname === RouterUrls.SIGN_IN || url.pathname === RouterUrls.SIGN_OUT;
  if (!isAuthPage && !urlClientId) {
    clearPendingTenantClientId();
  }

  const clientIdParameter = urlClientId ?? (isAuthPage ? getLogoutHandoffClientId() : null);
  return clientIdParameter && isValidClientId(clientIdParameter) ? clientIdParameter : null;
};

export const getUrlClientId = (): string | null => {
  const clientId = new URL(window.location.href).searchParams.get('clientId');

  return clientId && isValidClientId(clientId) ? clientId : null;
};

export const clearClientIdFromUrl = (): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete('clientId');
  if (url.searchParams.has('code') || url.searchParams.has('error')) {
    ['code', 'state', 'client_info', 'session_state', 'error', 'error_description'].forEach((parameter) =>
      url.searchParams.delete(parameter)
    );
  }
  const hash = new URLSearchParams(url.hash.slice(1));
  if (['code', 'id_token', 'access_token', 'error'].some((parameter) => hash.has(parameter))) {
    ['code', 'id_token', 'access_token', 'error', 'error_description', 'state', 'client_info', 'session_state'].forEach(
      (parameter) => hash.delete(parameter)
    );
    url.hash = hash.toString();
  }
  window.history.replaceState(window.history.state, '', url);
};

export const observeClientIdChanges = (canSwitchClient: () => boolean, isReady: () => boolean): (() => boolean) => {
  let previousClientId = getUrlClientId();
  let reloading = false;
  const checkForClientIdChange = (): boolean => {
    if (reloading) {
      return true;
    }
    if (!isReady()) {
      return false;
    }
    if (!canSwitchClient()) {
      previousClientId = getUrlClientId();
      return false;
    }

    const nextClientId = getUrlClientId();
    if (nextClientId === previousClientId) {
      return false;
    }

    clearPendingTenantClientId();
    previousClientId = nextClientId;
    reloading = true;
    window.location.reload();
    return true;
  };
  const originalPushState = window.history.pushState.bind(window.history);
  const originalReplaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = function (...args) {
    originalPushState(...args);
    checkForClientIdChange();
  };
  window.history.replaceState = function (...args) {
    originalReplaceState(...args);
    checkForClientIdChange();
  };
  window.addEventListener('popstate', checkForClientIdChange);
  return checkForClientIdChange;
};
